<template>
  <div class="order-edit-container">
    <el-card class="order-card">
      <div class="page-header">
        <h2>编辑订单</h2>
        <el-button @click="$router.back()">返回</el-button>
      </div>
      
      <el-form ref="orderForm" :model="orderForm" :rules="orderRules" label-width="120px" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">订单信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input v-model="orderForm.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号">
              <el-input v-model="orderForm.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="客户">
              <el-input v-model="orderForm.customer" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态">
              <el-tag :type="getStatusType(orderForm.status)" style="width: 100%; text-align: center;">{{ orderForm.status }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择商家" prop="merchantId">
              <el-select 
                v-model="orderForm.merchantId" 
                filterable 
                placeholder="请选择商家" 
                style="width: 100%"
                :loading="loading.merchants"
                @change="handleMerchantChange">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceId">
              <el-select 
                v-model="orderForm.deviceId" 
                filterable 
                placeholder="请选择仪器" 
                style="width: 100%"
                :disabled="!orderForm.merchantId"
                @change="handleEquipmentChange">
                <el-option
                  v-for="item in equipmentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="form-tip" v-if="!orderForm.merchantId">请先选择商家</div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="参考价格">
              <el-input v-model="orderForm.referencePrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际价格" prop="actualPrice">
              <el-input v-model="orderForm.actualPrice">
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系人" prop="merchantContact">
              <el-input v-model="orderForm.merchantContact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="merchantPhone">
              <el-input v-model="orderForm.merchantPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="地址" prop="merchantAddress">
              <el-input v-model="orderForm.merchantAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 物流信息部分 -->
        <template v-if="orderForm.status !== '未邮寄'">
          <el-divider content-position="left">
            <span class="divider-title">物流信息</span>
          </el-divider>
          
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="物流公司" prop="logisticsCompany">
                <el-input v-model="orderForm.logisticsCompany"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物流单号" prop="trackingNumber">
                <el-input v-model="orderForm.trackingNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="邮寄时间" prop="shipTime">
                <el-date-picker
                  v-model="orderForm.shipTime"
                  type="datetime"
                  placeholder="选择邮寄时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        
        <div class="form-actions">
          <el-button type="primary" @click="saveOrderEdit">保存</el-button>
          <el-button @click="cancelEdit">取消</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'EditMerchantInfo',
  data() {
    return {
      loading: {
        page: false,
        customers: false,
        merchants: false
      },
      originalOrderData: {
        id: '',
        merchantId: ''
      },
      orderForm: {
        projectName: '',
        customer: '',
        customerId: '',
        orderNo: '',
        merchantId: '',
        deviceId: '',
        merchantContact: '',
        merchantPhone: '',
        merchantAddress: '',
        referencePrice: '',
        actualPrice: '',
        status: '',
        // 物流信息
        logisticsCompany: '',
        trackingNumber: '',
        shipTime: ''
      },
      merchantOptions: [],
      equipmentOptions: [],
      merchantData: {},
      orderRules: {
        merchantId: [
          { required: true, message: '请选择商家', trigger: 'change' }
        ],
        deviceId: [
          { required: true, message: '请选择仪器', trigger: 'change' }
        ],
        merchantContact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        merchantPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        merchantAddress: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        actualPrice: [
          { required: true, message: '请输入实际价格', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 加载商家数据
    this.fetchMerchantList()
    
    // 获取订单详情
    const orderId = this.$route.params.id
    if (orderId) {
      this.fetchOrderDetail(orderId)
    }
  },
  methods: {
    async fetchOrderDetail(orderId) {
      this.loading.page = true
      try {
        // 调用API获取订单详情
        const res = await adminApi.getOrderById(orderId)
        if (res) {
          console.log('获取到的订单数据:', res)
          
          const orderData = res
          
          // 保存原始ID，在编辑时使用
          this.originalOrderData = {
            id: orderId,
            customerId: orderData.customerId,
            merchantId: orderData.merchantId
          }
          
          // 映射订单数据到表单
          this.orderForm = {
            projectName: orderData.projectName || '',
            customer: orderData.customerName || '',
            customerId: orderData.customerId || '',
            orderNo: orderData.orderSn || '',
            merchantId: orderData.merchantId || '',
            deviceId: orderData.deviceId || '',
            merchantContact: orderData.merchantPerson || '',
            merchantPhone: orderData.merchantPhone || '',
            merchantAddress: orderData.merchantAddress || '',
            referencePrice: orderData.guidePrice || '',
            actualPrice: orderData.actualPrice || '',
            status: this.getStatusText(orderData.orderStatus) || '未邮寄',
            // 物流信息
            logisticsCompany: orderData.trackName || '',
            trackingNumber: orderData.trackSn || '',
            shipTime: orderData.trackTime || ''
          }
          
          // 确保merchantData已经加载完成
          if (this.merchantData && Object.keys(this.merchantData).length > 0) {
            this.loadMerchantAndDeviceData();
          } else {
            // 等待merchantData加载完成
            const waitForMerchantData = setInterval(() => {
              if (this.merchantData && Object.keys(this.merchantData).length > 0) {
                clearInterval(waitForMerchantData);
                this.loadMerchantAndDeviceData();
              }
            }, 500);
            
            // 设置5秒超时，避免无限等待
            setTimeout(() => {
              clearInterval(waitForMerchantData);
              // 如果还没有商家数据，使用API加载设备
              if (this.orderForm.merchantId) {
                this.fetchEquipmentByMerchant(this.orderForm.merchantId);
              }
            }, 5000);
          }
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading.page = false
      }
    },
    
    // 从缓存加载商家和设备信息
    loadMerchantAndDeviceData() {
      if (this.orderForm.merchantId) {
        const merchantId = this.orderForm.merchantId;
        
        // 如果有商家数据缓存
        if (this.merchantData[merchantId]) {
          // 获取设备列表
          this.equipmentOptions = this.merchantData[merchantId].equipment || [];
          
          // 如果有设备ID，找到对应的设备信息
          if (this.orderForm.deviceId && this.equipmentOptions.length > 0) {
            const deviceId = this.orderForm.deviceId;
            const device = this.equipmentOptions.find(item => item.value === deviceId);
            
            if (device) {
              // 更新参考价格
              this.orderForm.referencePrice = device.price || this.orderForm.referencePrice;
            } else {
              // 如果没找到设备，需要手动加载
              this.fetchEquipmentByMerchant(merchantId);
            }
          } else if (this.equipmentOptions.length === 0) {
            // 如果没有设备列表，需要手动加载
            this.fetchEquipmentByMerchant(merchantId);
          }
        } else {
          // 如果没有商家数据缓存，手动加载
          this.fetchEquipmentByMerchant(merchantId);
        }
      }
    },
    
    async fetchMerchantList() {
      this.loading.merchants = true
      try {
        const res = await adminApi.getMerchantList()
        if (res) {
          // 处理商家选项列表
          this.merchantOptions = res.map(item => ({
            value: item.id.toString(),
            label: item.companyName
          }));
          
          // 创建商家数据字典，便于快速查找商家信息
          this.merchantData = {};
          res.forEach(item => {
            // 获取仪器列表
            const equipmentList = item.deviceInfoList || [];
            
            // 处理仪器选项
            const equipment = equipmentList.map(device => ({
              value: device.id.toString(),
              label: device.deviceName || `仪器ID:${device.id}`,
              price: device.price || '0',
              model: device.deviceModel || ''
            }));
            
            // 存储商家信息
            this.merchantData[item.id] = {
              contact: item.contactPerson || '',
              phone: item.contactPhone || item.phone || '',
              address: item.companyAddress || item.address || '',
              equipment: equipment
            };
          });
          
          // 如果是编辑模式，确保仪器信息正确加载
          if (this.originalOrderData.id && this.orderForm.merchantId) {
            const merchantId = this.orderForm.merchantId;
            if (this.merchantData[merchantId] && this.merchantData[merchantId].equipment.length > 0) {
              this.equipmentOptions = this.merchantData[merchantId].equipment;
            }
          }
        } else {
          this.merchantOptions = []
        }
      } catch (error) {
        console.error('获取商家列表失败:', error)
        this.$message.error('获取商家列表失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading.merchants = false
      }
    },
    
    async fetchEquipmentByMerchant(merchantId) {
      this.equipmentOptions = []
      this.orderForm.deviceId = ''
      
      if (this.merchantData && this.merchantData[merchantId]) {
        // 如果已经有商家数据，直接从缓存获取设备列表
        this.equipmentOptions = this.merchantData[merchantId].equipment || [];
        
        // 如果只有一个设备，自动选择
        if (this.equipmentOptions.length === 1) {
          this.orderForm.deviceId = this.equipmentOptions[0].value;
          this.handleEquipmentChange(this.orderForm.deviceId);
        }
        return;
      }
      
      // 如果没有缓存，则向后端请求
      try {
        const res = await adminApi.getDeviceListByMerchant(merchantId)
        if (res && Array.isArray(res.list)) {
          this.equipmentOptions = res.list.map(item => ({
            value: item.id,
            label: item.name,
            price: item.price,
            model: item.model || ''
          }))
          
          // 如果只有一个设备，自动选择
          if (this.equipmentOptions.length === 1) {
            this.orderForm.deviceId = this.equipmentOptions[0].value
            this.handleEquipmentChange(this.orderForm.deviceId)
          }
        } else {
          this.equipmentOptions = []
        }
      } catch (error) {
        console.error('获取仪器列表失败:', error)
        this.$message.error('获取仪器列表失败: ' + (error.message || '未知错误'))
      }
    },
    
    handleMerchantChange(merchantId) {
      if (merchantId) {
        this.fetchEquipmentByMerchant(merchantId)
        
        // 从商家数据中获取商家信息
        if (this.merchantData && this.merchantData[merchantId]) {
          // 根据选择的商家更新商家相关信息
          const merchantInfo = this.merchantData[merchantId];
          this.orderForm.merchantContact = merchantInfo.contact;
          this.orderForm.merchantPhone = merchantInfo.phone;
          this.orderForm.merchantAddress = merchantInfo.address;
        } else {
          // 如果没有缓存，则调用API获取
          this.fetchMerchantDetail(merchantId);
        }
      } else {
        this.equipmentOptions = []
        this.orderForm.deviceId = ''
        this.orderForm.referencePrice = ''
        this.orderForm.merchantContact = ''
        this.orderForm.merchantPhone = ''
        this.orderForm.merchantAddress = ''
      }
    },
    
    async fetchMerchantDetail(merchantId) {
      try {
        const res = await adminApi.getMerchantById(merchantId)
        if (res) {
          // 更新商家联系人等信息
          this.orderForm.merchantContact = res.contactPerson || res.person || ''
          this.orderForm.merchantPhone = res.contactPhone || res.phone || ''
          this.orderForm.merchantAddress = res.companyAddress || res.address || ''
        }
      } catch (error) {
        console.error('获取商家详情失败:', error)
      }
    },
    
    handleEquipmentChange(deviceId) {
      if (deviceId && this.orderForm.merchantId) {
        // 根据选择的仪器回填价格
        if (this.merchantData[this.orderForm.merchantId]) {
          const merchantEquipment = this.merchantData[this.orderForm.merchantId].equipment || [];
          const selectedEquipment = merchantEquipment.find(item => item.value === deviceId);
          
          if (selectedEquipment) {
            // 更新设备相关信息
            this.orderForm.referencePrice = selectedEquipment.price || '';
            // 如果实际价格为空，则设置为参考价格
            if (!this.orderForm.actualPrice) {
              this.orderForm.actualPrice = selectedEquipment.price || '';
            }
          }
        } else {
          // 从设备列表中获取设备信息
          const device = this.equipmentOptions.find(item => item.value === deviceId);
          if (device) {
            // 更新设备相关信息
            this.orderForm.referencePrice = device.price || '';
            // 如果实际价格为空，则设置为参考价格
            if (!this.orderForm.actualPrice) {
              this.orderForm.actualPrice = device.price || '';
            }
          }
        }
      } else {
        this.orderForm.referencePrice = '';
      }
    },
    
    getStatusType(status) {
      const statusMap = {
        '未邮寄': 'info',
        '配送中': 'primary',
        '即将到达': 'success',
        '已完成': 'success',
        '已取消': 'danger'
      }
      return statusMap[status] || 'info'
    },
    
    getStatusText(status) {
      const statusTextMap = {
        'NOT_SHIPPED': '未邮寄',
        'IN_TRANSIT': '在途',
        'TESTING': '测试中',
        'TESTED': '已测试',
        'DISPUTE': '复测/争议',
        'RETURN': '回寄',
        'FORWARD': '转寄',
        'UNSETTLED': '未结算',
        'COMPLETED': '已完成',
        'CANCEL': '已取消'
      }
      return statusTextMap[status] || status
    },
    
    saveOrderEdit() {
      this.$refs['orderForm'].validate((valid) => {
        if (valid) {
          // 额外检查必要的字段
          if (!this.orderForm.merchantId) {
            this.$message.error('请选择商家');
            return false;
          }
          
          if (!this.orderForm.deviceId) {
            this.$message.error('请选择仪器');
            return false;
          }
          
          this.$confirm('确认保存修改吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 获取商家名称
            let merchantName = '';
            const selectedMerchant = this.merchantOptions.find(item => item.value === this.orderForm.merchantId);
            if (selectedMerchant) {
              merchantName = selectedMerchant.label;
            }
            
            // 获取设备名称
            let deviceName = '';
            const selectedDevice = this.equipmentOptions.find(item => item.value === this.orderForm.deviceId);
            if (selectedDevice) {
              deviceName = selectedDevice.label;
            }
            
            // 构建要保存的数据，仅包含商家信息和物流信息
            const saveData = {
              id: this.originalOrderData.id,
              merchantId: this.orderForm.merchantId, // 直接使用当前表单的商家ID
              merchantName: merchantName, // 添加商家名称
              deviceId: this.orderForm.deviceId, // 直接使用当前表单的设备ID
              deviceName: deviceName, // 添加设备名称
              merchantPerson: this.orderForm.merchantContact,
              merchantPhone: this.orderForm.merchantPhone,
              merchantAddress: this.orderForm.merchantAddress,
              actualPrice: this.orderForm.actualPrice,
              trackName: this.orderForm.logisticsCompany,
              trackSn: this.orderForm.trackingNumber,
              trackTime: this.orderForm.shipTime
            }
            
            console.log('准备提交的订单数据:', saveData);
            
            // 调用保存API
            adminApi.updateOrderInfo(saveData)
              .then(response => {
                console.log('保存订单响应:', response)
                if (response) {
                  this.$message.success('修改成功')
                  // 返回上一页
                  this.$router.back()
                } else {
                  this.$message.error(response.msg || '保存失败')
                }
              })
              .catch(error => {
                console.error('保存订单失败:', error)
                this.$message.error('保存订单失败: ' + (error.message || '未知错误'))
              })
          }).catch(() => {
            this.$message.info('已取消保存')
          })
        } else {
          this.$message.error('表单填写有误，请检查!');
          return false;
        }
      });
    },
    
    // 取消编辑
    cancelEdit() {
      this.$confirm('确认取消编辑？未保存的修改将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 返回详情页
        this.$router.back()
      }).catch(() => {
        this.$message.info('已取消')
      })
    }
  }
}
</script>

<style scoped>
.order-edit-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.order-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.el-form-item {
  margin-bottom: 24px;
}

.form-actions {
  margin-top: 20px;
  text-align: center;
}

.form-actions .el-button {
  padding: 12px 30px;
  font-size: 16px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1;
  padding-top: 4px;
}
</style> 